/**
 * @generated SignedSource<<03ad9db22088fdd1e457a5121db18df3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type flag_nativeIssueTable_FlagCell$data = {
  readonly flag: {
    readonly isFlagged: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "flag_nativeIssueTable_FlagCell";
};
export type flag_nativeIssueTable_FlagCell$key = {
  readonly " $data"?: flag_nativeIssueTable_FlagCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"flag_nativeIssueTable_FlagCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "flag_nativeIssueTable_FlagCell",
  "selections": [
    {
      "concreteType": "JiraFlag",
      "kind": "LinkedField",
      "name": "flag",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFlagged"
        }
      ]
    }
  ],
  "type": "JiraFlagField"
};

(node as any).hash = "31300af4f47b42a3abf7e459bcad4233";

export default node;
